import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Aura from '@primeuix/themes/aura';
import ToastService from 'primevue/toastservice';
import 'primeicons/primeicons.css';
import App from './App.vue';
import router from './router';
import { recoverToLogin, isAuthFailure } from './lib/sessionRecovery';
import './styles/main.css';

const app = createApp(App);

app.config.errorHandler = (error, _instance, info) => {
  console.error('[vue error]', info, error);
};

window.addEventListener('unhandledrejection', (event) => {
  if (!isAuthFailure(event.reason)) {
    console.error('[unhandled rejection]', event.reason);
    return;
  }
  recoverToLogin(event.reason);
});

app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.dark-mode',
    },
  },
});
app.use(ToastService);

app.mount('#app');
